import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import { ICouponDetailsResponse, ICouponServiceProps } from "@/api_framework/api_modals/coupon";

AxiosCurlirize(axios, () => {});

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useCouponDetailsAPI = () => {
  const [couponDetails, setCouponDetails] = useState<ICouponServiceProps>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration(); 

  const execute = useCallback(
    async (coupon_id: string) => {
      dispatch(
        setLoading({
          key: "isCouponServiceDetailsInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${COUPON_SERVICE_APIS?.COUPON_LIST?.baseURL}/${coupon_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICouponDetailsResponse>) => {
            if (res.data.status) {
              setCouponDetails(res.data.data);
              dispatch(
                setLoading({
                  key: "isCouponServiceDetailsInProgress",
                  status: false,
                }),
              );
              return { status: true, message: null };
            } else {
              dispatch(
                setLoading({
                  key: "isCouponServiceDetailsInProgress",
                  status: false,
                }),
              );
              setCouponDetails(null);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isCouponServiceDetailsInProgress",
                status: false,
              }),
            );
            setCouponDetails(null);
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isCouponServiceDetailsInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
        setCouponDetails(null);
      }
    },
    [dispatch],
  );
  return { execute, couponDetails };
};
